import * as React from "react";
const SvgFiRrGlassHalf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22.212.973A3 3 0 0 0 20 0H4c-.836 0-1.64.353-2.206.967a3 3 0 0 0-.784 2.279L2.34 19.41C2.551 21.984 4.74 24 7.321 24h9.264a4.97 4.97 0 0 0 4.98-4.562l1.422-16.175a3.01 3.01 0 0 0-.776-2.29M3.265 2.322A.99.99 0 0 1 4 2h16c.284 0 .546.115.737.324s.283.48.26.764L20.3 11H3.655l-.65-7.918a1 1 0 0 1 .26-.76M16.586 22H7.322a3.017 3.017 0 0 1-2.989-2.754L3.82 13h16.305l-.55 6.263A2.984 2.984 0 0 1 16.584 22z"
    />
  </svg>
);
export default SvgFiRrGlassHalf;
